import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, UrlSegment, Router } from '@angular/router';
import { RuleService } from '../../infrastructure/services/reglas.service';
import { LoaderService } from '../../infrastructure/services/loader.service';

import 'brace/mode/csharp';
import { Observable } from 'rxjs/Observable';
import { AlertService, GrowlType } from '../../infrastructure/services/alert.service';
import { Translator } from 'angular-translator';
import { Rule, RuleComponent, TryCompileRequest } from 'app/infrastructure/model/interfaces/rule.interface';
import { RuleCompilationResult } from 'app/infrastructure/model/classes/rule.class';

@Component({
  templateUrl: './reglas.editor.component.html',
  styleUrls: ['./reglas.editor.component.css'],
})
export class RuleEditorComponent implements OnInit {
  regla: Rule;
  codRegla: string;
  codSistema: string;
  codNegocio: string;
  codProducto: string;
  buildResult: string[];
  buildSourceCode: string;
  isConsultaSimple: boolean = false;
  text: string;

  compilationResult: RuleCompilationResult;

  options: any = { maxLines: 1000, printMargin: true };
  comentario: '';
  componentes: RuleComponent[];
  readonly ConsultaSimple: string = "consultaSimple";
  renderComponents: boolean = false;

  constructor(private aRoute: ActivatedRoute,
    public router: Router,
    public loader: LoaderService,
    private reglasService: RuleService,
    private alertService: AlertService,
    private translate: Translator) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.codRegla = params['codRegla'];
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];
      this.codProducto = params['codproducto'];

      this.isConsultaSimple = this.router.url.includes(this.ConsultaSimple);

      this.reglasService.getRegla(this.codRegla)
        .then(regla => {
          this.regla = regla; 
          this.text = this.regla.textoRegla;

          this.reglasService.getComponentes(regla.codReglaEvento, regla.codServicio)
            .then(componentes => this.componentes = componentes);
        });
    });
  }

  showComponents(){
    this.renderComponents = !this.renderComponents
  }

  tryCompile() {
    const tryCompileData: TryCompileRequest = {
      ruleId: this.regla.idRegla,
      ruleCode: this.text,
      systemCode: this.codSistema,
      businessCode: this.codNegocio,
      productCode: this.codProducto,
    };
    this.reglasService.tryCompile(tryCompileData).subscribe(
      data => {
        this.compilationResult = data.compileResult;

        if (data.compileResult.isOk()) {
          this.alertService.showGrowl({
            body: 'RULE_COMPILED_SUCCESSFULLY',
            type: GrowlType.SUCCESS,
          });
        }
      }
    );
  }

  guardar(saveAndClose:boolean) {
    this.regla.textoRegla = this.text;
    this.regla.comentario = this.comentario;
    this.compilationResult = undefined;

    this.reglasService
    .editar(this.regla)
    .then(regla => {
      this.comentario = '';
      this.regla = regla;
      this.text = this.regla.textoRegla;
    });

    if(saveAndClose === true){
      this.router.navigate(['../../'], { relativeTo: this.aRoute });
    }
  }

  
  openSourceCodeTab(error) {
    const wnd = window.open('', '_blank');
    wnd.document.write(error);
    //wnd.document.write(JSON.stringify(error, null, '---------?'));
    wnd.document.title = 'RULE_EXCEPTION_IN: '+this.regla.idRegla;
    window.focus();
  }

  invalidateCache(){
    this.reglasService.invalidateCache(this.codRegla, this.codSistema,
      this.codNegocio, this.codProducto);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/reglas/reglas.editor.component.ts